'use strict';

class SearchBar {
  constructor($scope, $location, $timeout, recipientService, invoiceService, offerService, orderConfirmationService) {
    this.$scope = $scope;
    this.$location = $location;
    this.$timeout = $timeout;
    this.recipientService = recipientService;
    this.invoiceService = invoiceService;
    this.offerService = offerService;
    this.orderConfirmationService = orderConfirmationService;
  }

  $onInit() {
    this.results = [];

    let promise;
    this.$scope.$watch('$ctrl.q', (val, old) => {
      this.$timeout.cancel(promise);

      promise = this.$timeout(() => {
        this.results = [];

        if (val && val !== old) {
          this.lookup(val);
        }
      }, 300);
    });

    this.$scope.$on('$locationChangeSuccess', () => {
      this.results = [];
      this.q = null;
    });
  }

  lookup(val) {
    if (!isNaN(val) && parseInt(val, 10) < 2147483647) {
      // invoices
      this.invoiceService.get(val)
        .then((resp) => {
          // creditnote
          if (resp.data.credit) {
            this.results.push({
              path: 'kreditnota',
              number: resp.data.number,
              customerNumber: null,
              recipientName: resp.data.recipient.name
            });
          } else {
            this.results.push({
              path: 'regning',
              number: resp.data.number,
              customerNumber: null,
              recipientName: resp.data.recipient.name
            });
          }
        });

      // offers
      this.offerService.getOffer(val)
        .then((resp) => {
            this.results.push({
              path: 'tilbud',
              number: resp.data.number,
              customerNumber: null,
              recipientName: resp.data.recipient.name
            });
        });

      // order confirmations
      this.orderConfirmationService.getOrderConfirmation(val)
        .then((resp) => {
            this.results.push({
              path: 'ordrebekreftelse',
              number: resp.data.number,
              customerNumber: null,
              recipientName: resp.data.recipient.name
            });
        });
    }

    if (!isNaN(val) && (val.length === 10 || val.length === 18) && /^\d+$/.test(val)) {
      this.invoiceService.getByKid(val)
        .then((resp) => {
          // creditnote
          if (resp.data.credit) {
            this.results.push({
              path: 'kreditnota',
              number: resp.data.number,
              customerNumber: null,
              recipientName: resp.data.recipient.name
            });
          } else {
            this.results.push({
              path: 'regning',
              number: resp.data.number,
              customerNumber: null,
              recipientName: resp.data.recipient.name
            });
          }
        });
    }

    // recipients
    this.recipientService.search(val, 10)
      .then((resp) => {
        if (resp.data.recipients.length) {
          resp.data.recipients.forEach((recipient) => {
            this.results.push({
              path: 'kunde',
              number: recipient.number,
              customerNumber: recipient.recipientNo,
              recipientName: recipient.name
            });
          }, this);
        }
      });
  }

  select(index) {
    let clone = angular.copy(this.results);

    this.results = [];
    this.q = null;

    this.$location.path(`/${clone[index].path}/${clone[index].number}`);
  }
}

SearchBar.$inject = ['$scope', '$location', '$timeout', 'recipientService', 'invoiceService', 'offerService', 'orderConfirmationService'];

const searchBar = {
  controller: SearchBar,
  template: `
    <div id="searchbar">
      <i class="fa fa-search"></i>
      <input type="search" ng-model="$ctrl.q" placeholder="S&oslash;k (navn, nummer eller KID)">

      <ul ng-if="$ctrl.results.length">
        <li ng-repeat="item in $ctrl.results track by $index">
          <a ng-if="item.path !== 'kunde'" ng-click="$ctrl.select($index)" href>{{ item.path | capitalize }} {{ item.number }} - {{ item.recipientName }}</a>
          <a ng-if="item.path === 'kunde'" ng-click="$ctrl.select($index)" href>{{ item.path | capitalize }} {{ item.customerNumber }} - {{ item.recipientName }}</a>
        </li>
      </ul>
    </div>
  `
};

angular
  .module('sr.search', [])
  .component('searchBar', searchBar);
